<div class="container">

  <app-shared-action-bar [displayActionSectionBar]="false"></app-shared-action-bar>

  <div class="md:mx-2 mt-20">
    <h1 class="p-2">Select {{ 'audit' | customerTerm }}</h1>
    <div class="px-4 flex lg:flex-row flex-col mt-8" role="tablist" [attr.aria-label]="'Audit status' | customerText">
      <button
        type="button"
        class="w-52 border p-2 rounded-tl-md lg:rounded-tr-none rounded-tr-md lg:rounded-bl-md cursor-pointer text-center"
        [ngClass]="{'border-green-300': viewMode === 'active', 'border-grey-900': viewMode !== 'active', 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': viewMode === 'active'}"
        (click)="viewMode = 'active'"
        role="tab"
        [attr.aria-selected]="viewMode === 'active'">
        <span class="p-4" [ngClass]="{'text-green-700': viewMode === 'active', 'font-bold': viewMode === 'active'}">Active {{ 'audit' | customerTerm:true }}</span>
      </button>
      <button
        type="button"
        class="w-52 border p-2 lg:rounded-tr-md lg:rounded-bl-none rounded-bl-md rounded-br-md cursor-pointer text-center"
        [ngClass]="{'border-green-300': viewMode === 'removed', 'border-grey-900': viewMode !== 'removed', 'shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px]': viewMode === 'removed'}"
        (click)="viewMode = 'removed'"
        role="tab"
        [attr.aria-selected]="viewMode === 'removed'">
        <span class="p-4" [ngClass]="{'text-green-700': viewMode === 'removed', 'font-bold': viewMode === 'removed'}">Removed {{ 'audit' | customerTerm:true }}</span>
      </button>
    </div>
    <!--<h1 class="lg:px-8 mt-4 p-2">Select Audit</h1>-->
    @if (audits!=undefined && viewMode === 'active') {
      <div class="px-4 mt-4">
        <div class="border border-grey-200 rounded-lg p-4 bg-white shadow-sm">
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-3">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-grey-700">Search by name</label>
              <input
                pInputText
                type="text"
                class="w-full prime-input text-box mt-0"
                [(ngModel)]="searchText"
                [placeholder]="'Type part of the audit name' | customerText" />
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-grey-700">{{ 'audit' | customerTerm }} type</label>
              <p-select
                styleClass="w-full prime-input"
                [options]="auditTypeOptions"
                optionLabel="description"
                optionValue="id"
                [(ngModel)]="selectedAuditTypeId"
                [placeholder]="'All Audit Types' | customerText">
              </p-select>
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-grey-700">{{ 'audit' | customerTerm }} category</label>
              <p-select
                styleClass="w-full prime-input"
                [options]="[
                  { label: ('All Audits' | customerText), value: 'all' },
                  { label: 'Event information', value: 'event' },
                  { label: 'Feedback requests', value: 'campaign' },
                  { label: ('Standard Audits' | customerText), value: 'standard' }
                ]"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="auditCategoryFilter"
                [placeholder]="'All Audits' | customerText">
              </p-select>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 ">
        <ul class="mt-4">
          @for (a of filteredAudits; track a) {
            <li>
              <div class="border my-2 border-grey-900 rounded-lg p-4 ">
                <div class="flex flex-col md:flex-row justify-between w-full">
                  <div class="flex flex-col items-baseline pr-5 flex-grow">
                    <div class="flex items-center gap-2">
                      <h3>{{a.AuditName}}</h3>
                      @if (isInternalAudit(a)) {
                        <span class="inline-flex items-center gap-1 text-xs text-grey-700 border border-grey-300 rounded-full px-2 py-0.5">
                          <i class="pi pi-lock text-xs"></i>
                          <span class="text-xs">Restricted</span>
                        </span>
                      }
                    </div>
                    <p class=""><span class="text-sm text-grey-900">{{ 'audit' | customerTerm }} Type:
                    </span>{{a.AuditInfo.AuditType.Description}}</p>
                 
                </div>
                @if (true) {
                  <div class="border-[1px] border-grey-900 rounded-lg px-2 flex flex-col justify-center mt-4 md:mt-0 mr-6 w-40 h-12 items-center"
                    >
                    @if (a.IsEventAudit) {
                      <p class="text-center text-sm">Event</p>
                    } @else if (a.AuditEntryOptions.CampaignAudit) {
                      <p class="text-center text-sm">Feedback request</p>
                    } @else {
                      @if (a.AuditInfo.Frequency.ID!=1 && a.AuditInfo.FrequencyMultiplier>1) {
                        <p class="text-center font-bold text-green-700">
                        {{a.AuditInfo.FrequencyMultiplier}}x</p>
                      }
                      @if (a.AuditInfo.Frequency.ID==1) {
                        <p class="text-center text-sm">Ad Hoc</p>
                      }
                      @if (a.AuditInfo.Frequency.ID!=1) {
                        <div class="flex">
                          <span class="mx-1"
                          [ngClass]="{'text-green-400 font-bold':a.AuditInfo.Frequency.ID == 2,'text-grey-500':a.AuditInfo.Frequency.ID != 2}">d</span>
                          <span class="mx-1"
                          [ngClass]="{'text-green-400 font-bold':a.AuditInfo.Frequency.ID == 3,'text-grey-500':a.AuditInfo.Frequency.ID != 3}">w</span>
                          <span class="mx-1"
                          [ngClass]="{'text-green-400 font-bold':a.AuditInfo.Frequency.ID == 5,'text-grey-500':a.AuditInfo.Frequency.ID != 5}">m</span>
                          <span class="mx-1"
                          [ngClass]="{'text-green-400 font-bold':a.AuditInfo.Frequency.ID == 6,'text-grey-500':a.AuditInfo.Frequency.ID != 6}">q</span>
                          <span class="mx-1"
                          [ngClass]="{'text-green-400 font-bold':a.AuditInfo.Frequency.ID == 7,'text-grey-500':a.AuditInfo.Frequency.ID != 7}">sa</span>
                          <span class="mx-1"
                          [ngClass]="{'text-green-400 font-bold':a.AuditInfo.Frequency.ID == 8,'text-grey-500':a.AuditInfo.Frequency.ID != 8}">a</span>
                        </div>
                      }
                    }
                  </div>
                }
                <div class="flex justify-between items-center md:mt-0  mt-3 ">
                  <div class="flex flex-col md:flex-row text-sm group cursor-pointer mr-2"
                    (click)="selectAudit(a)"><span
                  class=" material-symbols-outlined text-2xl group-hover:text-green-400 items-center md:mr-1">edit</span><span
                class="text-sm text-green-300 ">edit</span></div>
                <div class="flex flex-col md:flex-row text-sm group cursor-pointer mr-2"
                  (click)="duplicateAudit(a)"><span
                class=" material-symbols-outlined text-2xl group-hover:text-grey-900 items-center md:mr-1">file_copy</span><span
              class="text-sm text-grey-900 ">copy</span></div>
              <div class="flex flex-col md:flex-row text-sm group cursor-pointer"
                (click)="setDelete(a.AuditID)"><span
              class=" material-symbols-outlined text-2xl  group-hover:text-danger-base items-center md:mr-1">delete</span><span
            class="text-sm text-danger-base">delete</span></div>
          </div>
        </div>
        @if (forDeletion(a.AuditID)) {
          <div class="my-6 p-3 border-grey-300 border-2 rounded-md mx-4">
            <h4 class="mb-2">Confirm {{ 'audit' | customerTerm }} Removal</h4>
            <p>{{ 'Once inactive, the audit will be removed from the list of audits that can be completed.' | customerText }}</p>
            <p><strong>NOTE - This is for all users at all locations.</strong></p>
            <div class="flex my-5">
              <button class="btn-primary btn-negative mr-2" (click)="deleteAudit(a.AuditID)"
              [disabled]="attemptingDelete(a.AuditID)">Confirm Removal</button>
              <button class="btn-inverse" (click)="setDelete(a.AuditID)">Cancel</button>
            </div>
          </div>
        }
      </div>
    </li>
  }
</ul>
</div>
}
@if (viewMode === 'removed') {
  <div class="px-4 mt-4">
    @if (loadingRemovedAudits) {
      <p>{{ 'Loading removed audits...' | customerText }}</p>
    } @else if (removedAudits.length === 0) {
      <p class="text-grey-700">{{ 'There are no removed audits available to reactivate.' | customerText }}</p>
    } @else {
      <ul>
        @for (audit of removedAudits; track audit.AuditID) {
          <li class="border my-2 border-grey-900 rounded-lg p-4 flex flex-col md:flex-row md:items-center justify-between gap-3">
            <div>
              <h3>{{audit.AuditName}}</h3>
              <p class="text-sm text-grey-900">{{ 'audit' | customerTerm }} Type: {{audit.AuditInfo.AuditType.Description}}</p>
            </div>
            <button class="btn-primary" (click)="reactivateAudit(audit)" [disabled]="reactivatingAuditIds.has(audit.AuditID)">
              @if (reactivatingAuditIds.has(audit.AuditID)) { Reactivating... } @else { Reactivate }
            </button>
          </li>
        }
      </ul>
    }
  </div>
}
</div>

</div>
